<template>
    <div>
        <b-card class="d-none d-sm-block">
            <div slot="header" style="margin-top:-7px;margin-bottom:-8px">Lönespecfikationer för perioden
                <date-picker id="dateDropdown" lang="en" v-model="selectedDate" type="month" format="YYYY-MM" 
                    v-on:change="dateChanged()"  /> 
                <div class="card-header-actions">
                    <b-spinner v-if="loading" class="mr-1" type="border" small />
                </div>
            </div>
            <SpecificationsTable :salarySpecifications="salarySpecifications" @onLoading="onLoading" @onSalarySpecificationSelected="onSalarySpecificationSelected" keyId="period"/>
        </b-card>
        <b-card class="d-md-none">
            <div slot="header">Lönespecfikationer för perioden {{this.$moment(this.selectedDate).format("YYYY-MM")}}
                <div class="card-header-actions">
                    <b-spinner v-if="loading" class="mr-1" type="border" small />
                </div>
            </div>
            <SpecificationsTable :salarySpecifications="salarySpecifications" @onLoading="onLoading" @onSalarySpecificationSelected="onSalarySpecificationSelected" keyId="period"/>
        </b-card>                    
    </div>

</template>

<script>
import DatePicker from 'vue2-datepicker'
import { salarySpecificationService } from "../../../shared/services";
import SpecificationsTable from "./SpecificationsTable"

export default {
    components: {
        DatePicker,
        SpecificationsTable
    },
    methods: {
        dateChanged() {
            if(!this.selectedDate) this.selectedDate = this.$moment();
            this.$emit("onPeriodChanged", this.selectedDate);
            this.getSalarySpecifications();
        },
        getSalarySpecifications() {
            
            this.loading = true;
            salarySpecificationService.getByDate(this.$moment(this.selectedDate).format("YYYY-MM-01")).then(p => {
                this.loading = false;
                this.salarySpecifications = p;
            }).catch(p => 
            {
                this.loading = false;
                this.ShowToast("Fel", "Ett okänt fel uppstod då lönespecifikationer för innevarande månad skulle hämtas", "danger")
            });
        },
        onLoading(loading) {
            this.loading = loading;
        },
        onSalarySpecificationSelected(salarySpecification) {
            this.$router.push({ path: `salaryspecifications/${salarySpecification.id}` });
        },
    },
    data() {
        return {
        componentKey: 0,
        loading: false,
        salarySpecifications: [],
        selectedDate: null
        };
    },
    mounted() {
        this.selectedDate = this.$moment();
        this.getSalarySpecifications();
    }
}
</script>

<style>

</style>
